import { createContext, useContext } from 'react';
import type { User, Session } from '@supabase/supabase-js';

export interface Profile {
  id: string;
  nickname: string | null;
  role: 'user' | 'admin';
  created_at: string;
  updated_at: string;
}

export type SocialProvider = 'google' | 'kakao';

export interface AuthState {
  user: User | null;
  profile: Profile | null;
  session: Session | null;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<{ error: string | null }>;
  signUp: (email: string, password: string, nickname: string) => Promise<{ error: string | null; user: User | null; hasSession: boolean }>;
  signOut: () => Promise<void>;
  signInWithOAuth: (provider: SocialProvider) => Promise<{ error: string | null }>;
  refreshProfile: () => Promise<void>;
  isAdmin: boolean;
  hasAgreements: boolean;
  agreementsChecked: boolean;
  recordAgreements: () => Promise<{ error: string | null }>;
  needsTermsConsent: boolean;
  isRecoverySession: boolean;
}

// react-refresh/only-export-components 경고를 피하기 위해
// Context/타입/hook(useAuth)과 Provider 컴포넌트(AuthProvider)를 별도 파일로 분리한다.
export const AuthContext = createContext<AuthState | undefined>(undefined);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return ctx;
}